export var COMPARE_WITH = [
    { key: '0', name: 'Value' },
    { key: '1', name: 'Plugin' },
];
export var BOOL_STATEMENTS = [
    { key: '0', value: 'boolEq', name: 'Is equal to', exp: '=', type: 'context' },
    { key: '1', value: 'boolNeq', name: 'Is not', exp: '!=', type: 'context' },
    { key: '2', name: 'Has been', exp: '=', type: 'historical', negate: false },
    { key: '3', name: 'Has not been', exp: '=', type: 'historical', negate: true },
];
export var DATE_TIME_STATEMENTS = [
    { key: '0', value: 'eq', name: 'Is', exp: '=', type: 'context' },
    { key: '1', value: 'greq', name: 'Is after', exp: '>=', type: 'context' },
    { key: '2', value: 'lseq', name: 'Is before', exp: '<=', type: 'context' },
    { key: '3', value: 'neq', name: 'Is not', exp: '!=', type: 'context' },
    { key: '4', name: 'Has been', exp: '=', type: 'historical', negate: false },
    { key: '5', name: 'Has been after', exp: '>', type: 'historical', negate: false },
    { key: '6', name: 'Has been before', exp: '<', type: 'historical', negate: false },
    { key: '7', name: 'Has not been', exp: '=', type: 'historical', negate: true },
    { key: '8', name: 'Has not been after', exp: '>', type: 'historical', negate: true },
    { key: '9', name: 'Has not been before', exp: '<', type: 'historical', negate: true },
];
export var INT_FLOAT_STATEMENTS = [
    { key: '0', value: 'eq', name: 'Is equal to', exp: '=', type: 'context' },
    { key: '1', value: 'gr', name: 'Is greater than', exp: '>', type: 'context' },
    { key: '2', value: 'greq', name: 'Is greater than or equal to', exp: '>=', type: 'context' },
    { key: '3', value: 'ls', name: 'Is less than', exp: '<', type: 'context' },
    { key: '4', value: 'lseq', name: 'Is less than or equal to', exp: '<=', type: 'context' },
    { key: '5', value: 'neq', name: 'Is not equal to', exp: '!=', type: 'context' },
    { key: '6', name: 'Has been', exp: '=', type: 'historical', function: 'count', negate: false },
    { key: '7', name: 'Has been greater than', exp: '>', type: 'historical', function: 'count', negate: false },
    { key: '8', name: 'Has been less than', exp: '<', type: 'historical', function: 'count', negate: false },
    { key: '9', name: 'Has not been', exp: '=', type: 'historical', function: 'count', negate: true },
    { key: '10', name: 'Has not been greater than', exp: '>', type: 'historical', function: 'count', negate: true },
    { key: '11', name: 'Has not been less than', exp: '<', type: 'historical', function: 'count', negate: true },
    { key: '12', name: 'Sum of values that are equal to', exp: '=', type: 'historical', function: 'sum', negate: false },
    {
        key: '13',
        name: 'Sum of values that are not equal to',
        exp: '=',
        type: 'historical',
        function: 'sum',
        negate: true,
    },
    {
        key: '14',
        name: 'Sum of values that have been greater than',
        exp: '>',
        type: 'historical',
        function: 'sum',
        negate: false,
    },
    {
        key: '15',
        name: 'Sum of values that have not been greater than',
        exp: '>',
        type: 'historical',
        function: 'sum',
        negate: true,
    },
    {
        key: '16',
        name: 'Sum of values that have been less than',
        exp: '<',
        type: 'historical',
        function: 'sum',
        negate: false,
    },
    {
        key: '17',
        name: 'Sum of values that have not been less than',
        exp: '<',
        type: 'historical',
        function: 'sum',
        negate: true,
    },
];
export var STRING_STATEMENTS = [
    { key: '0', value: 'stringFoldEq', name: 'Is', exp: '=', type: 'context' },
    { key: '1', value: 'stringFoldNeq', name: 'Is not', exp: '!=', type: 'context' },
    { key: '2', value: 'stringFoldContains', name: 'Contains', exp: '=', type: 'context' },
    { key: '3', name: 'Has been', exp: '=', type: 'historical', negate: false },
    { key: '4', name: 'Has not been', exp: '=', type: 'historical', negate: true },
];
export var CTX_HISTORY_RESULT_STATEMENTS = [
    { key: '0', value: 'eq', name: 'Is equal to', exp: '=', type: 'context' },
    { key: '1', value: 'gr', name: 'Is greater than', exp: '>', type: 'context' },
    { key: '2', value: 'greq', name: 'Is greater than or equal to', exp: '>=', type: 'context' },
    { key: '3', value: 'ls', name: 'Is less than', exp: '<', type: 'context' },
    { key: '4', value: 'lseq', name: 'Is less than or equal to', exp: '<=', type: 'context' },
    { key: '5', value: 'neq', name: 'Is not equal to', exp: '!=', type: 'context' },
];
export var BOOL_VALUES = [
    { key: 'true', name: 'True' },
    { key: 'false', name: 'False' },
];
export var LIMIT_VALUES = [
    { key: '0', name: 'at least', exp: 'greq' },
    { key: '1', name: 'at most', exp: 'lseq' },
    { key: '2', name: 'exactly', exp: 'eq' },
    { key: '3', name: 'less than', exp: 'ls' },
    { key: '4', name: 'more than', exp: 'gr' },
];
export var DURATION_UNIT_VALUES = [
    { key: '0', name: 'minute(s)', seconds: 60 },
    { key: '1', name: 'hour(s)', seconds: 3600 },
    { key: '2', name: 'day(s)', seconds: 86400 },
];
//# sourceMappingURL=dropdowns.js.map